import { atom } from "recoil";

export const tournamentsStore = atom({
	key: "tournamentsStore",
	default: {
		loaded: false,
		data: [],
		error: {
			text: "",
			code: 0,
			timestamp: 0,
		},
		currentOption: {
			status: [{
				value: "active",
				label: "Active",
			},{
				value: "finished",
				label: "Finished"
			},
			{
				value: "all",
				label: "All"
			}],
		},
		currentStatus: undefined,
		sorting: {
			sortingColumn: {
				order: "",
				column: "",
			},
			isDescending: false,
		},
		pagination: {
			current: 1,
			total: 0,
			count: 0,
		},
	},
});
